import React from "react";
import "./register.css";
import axios from "axios"
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setUserDetails } from "../../store/userdetails";



function Register({quit}){
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const [user, setUser] = React.useState(
        {
            "username" : "",
            "email" : "",
            "first_name" : "",
            "last_name" : "",
            "password" : "",
            "role" : "",
        }
    )

    function handleChange(event){
        const {name , value} = event.target
        setUser(prevdata => ({...prevdata, [name]: value}))
    }

    const handleSubmit = (e) =>{
        e.preventDefault()
        console.log(user)
        axios.post("http://localhost:8000/api/auth-register/", user)
            .then(res => {

                localStorage.setItem("auth", JSON.stringify(res.data))
                localStorage.setItem("user", JSON.stringify(res.data.user))
                dispatch(setUserDetails(res.data.user))
                navigate("/dashboard")

            })

            .catch((error) => console.log(error))
    }




    return(
        <div className="cont">
        
            <div className="exit--button" onClick={quit}><i className="fa-solid fa-xmark"></i></div>

            <div className="form--container1">
                <form className="forms2" onSubmit={handleSubmit}>
                    
                    <label htmlFor="username">Username</label>
                    <input value={user.username} onChange={ (event)=> handleChange(event) } name="username" type="text" className="input--box--register" id="username"/>
                    <label htmlFor="last_name">Lastname</label>
                    <input value={user.last_name} onChange={ (event)=> handleChange(event) } name="last_name" type="text" className="input--box--register" id="last_name"/>
                    <label htmlFor="first_name">Firstname</label>
                    <input value={user.first_name} onChange={ (event)=> handleChange(event) } name="first_name" type="text" className="input--box--register" id="first_name"/>
                    <label htmlFor="email">Email</label>
                    <input value={user.email} onChange={ (event)=> handleChange(event) } name="email" type="email" className="input--box--register" id="email"/>
                    <label htmlFor="password">Password</label>
                    <input value={user.password} onChange={ (event)=> handleChange(event) } name="password" type="password" className="input--box--register" id="password"/>
                    
                    <div className="wrapper">

                        <label className="option option-1">

                            <input
                                type="radio"
                                name="role"
                                value="student"
                                id="option-1"
                                checked={user.role === "student"}
                                onChange={handleChange}
                                className="option-1"
                            />
                            <div className="dot"></div>
                            <span>Attend an Exam</span>

                        </label>
                       
                    
                    
                        <label className="option option-2">

                            <input
                                type="radio"
                                name="role"
                                value="administrator"
                                id="option-2"
                                checked={user.role === "administrator"}
                                onChange={handleChange}
                                className="option-2"
                            />
                            <div className="dot"></div>
                            <span>Exam administrator</span>

                        </label>
                        
                    </div>

                    <button className="submit--button" >
                        Login
                        <span></span><span></span><span></span><span></span>
                    </button>

                    <h3>You already have an account?<small><Link to="/login">You can login here</Link></small></h3>
                
                </form>
                <hr></hr>
                <div className="form--illustration"></div>
            </div>
        </div>
    )
}

export default Register;